import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Alert } from '@components';
import FormSubmissionSuccessAlertContent from '@components/Content/AlertContent/FormSubmissionSuccessAlertContent';
import { iCourtFormValues } from '@services/CourtService';
import DoneIcon from '../../../../images/done.svg';
import InfoIcon from '../../../../images/info.svg';

function CourtStep12(): ReactElement {
  const { values }: { values: iCourtFormValues } = useFormikContext();
  const emailAddress = values.Email;
  const submissionNumber = values.submissionNo;
  const sendEmailCopy = values.EMAIL_TO;

  return (
    <div>
      <span className="vfH2">Your application has been successfully submitted</span>
      <Alert
        title="For your records"
        message={<FormSubmissionSuccessAlertContent submissionNumberAlertInfo={submissionNumber as string} email={emailAddress as string} hasEmailCopy={sendEmailCopy} />}
        icon={DoneIcon}
        theme="success"
        color="green"
      />
      <Alert
        title="What will happen next?"
        message="Once a decision has been made regarding your submission, you'll receive a notification in the post with the outcome"
        icon={InfoIcon}
        theme="info2"
      />
    </div>
  );
}

export default CourtStep12;
